<template>
  <div>
    <div class="container">
      <div
        :class="[
          'd-flex',
          prefix == 'gerencia'
            ? 'justify-content-end'
            : 'justify-content-between',
        ]"
      >
        <div class="mt-3 mb-4" v-if="prefix !== 'gerencia'">
          <button
            type="button"
            class="btn btn-secondary"
            @click="mtdChangeView('box')"
          >
            <i class="fas fa-arrow-left"></i> Volver
          </button>
        </div>
        <div class="btn-home mt-3 mb-4">
          <button
            type="button"
            class="btn btn-outline-main"
            @click="mtdChangeView('home')"
          >
            <i class="fas fa-home-lg-alt"></i> Inicio
          </button>
        </div>
      </div>
      <div id="div-modal-cxc" class="d-flex justify-content-center">
        <div id="div-cxc" class="card w-100 mb-lg-5">
          <div class="text-center card-header text-white h4 bg-main">
            <strong>CONSULTAR DOCUMENTO</strong>
          </div>
          <div class="card-body w-100">
            <div class="row">
              <div class="col-md-12 py-2">
                <div class="row d-flex mx-0">
                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mt-1">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text col-md-4">Desde</span>
                      <input
                        type="date"
                        aria-label="shift_date"
                        class="form-control form-control-sm"
                        id="begindate"
                        v-model="filter.begindate"
                        @change="mtdGetData"
                      />
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mt-1">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text col-md-4">Hasta</span>
                      <input
                        type="date"
                        aria-label="shift_date"
                        class="form-control form-control-sm"
                        id="end"
                        v-model="filter.enddate"
                        @change="mtdGetData"
                      />
                    </div>
                  </div>
                  <div
                    class="col-xl-3 col-md-3 col-lg-3 col-sm-12 col-xs-12 mt-1"
                  >
                    <div class="input-group input-group-sm">
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="checkboxBoleta"
                          v-model="filter.boleta"
                          @change="mtdSearchFilter"
                        />
                        <label class="form-check-label" for="checkboxBoleta">
                          Boleta
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="checkboxFactura"
                          v-model="filter.factura"
                          @change="mtdSearchFilter"
                        />
                        <label class="form-check-label" for="checkboxFactura">
                          Factura
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="checkboxTicket"
                          v-model="filter.ticket"
                          @change="mtdSearchFilter"
                        />
                        <label class="form-check-label" for="checkboxTicket">
                          Ticket
                        </label>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xl-2 col-md-2 col-lg-2 col-sm-12 col-xs-12 mt-1 text-center"
                  >
                    <div class="input-group input-group-sm">
                      <span class="input-group-text text-white bg-main"
                        ><i class="fas fa-funnel-dollar"></i>&nbsp;Total</span
                      >
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        placeholder="Buscar dni o nombre de paciente, o por número de boleta..."
                        disabled
                        v-model="cpTotalFiltro"
                      />
                    </div>
                  </div>
                  <div
                    class="col-xl-1 col-md-1 col-lg-1 col-sm-12 col-xs-12 mt-1 text-center"
                  >
                    <button
                      type="button"
                      class="btn text-white btn-sm bg-main w-100"
                      @click="mtdDownloadExcel"
                    >
                      <i class="fas fa-file-excel"></i>
                    </button>
                  </div>
                  <div class="col-md-9 col-lg-9 col-sm-9 col-xs-9 mt-3">
                    <div class="input-group input-group-sm">
                      <span
                        class="input-group-text text-white bg-main cursor-pointer"
                      >
                        <i class="fas fa-search"></i>&nbsp;&nbsp;Filtrar
                      </span>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        placeholder="Buscar DNI o nombre de Paciente o tipo de documento"
                        v-model="search"
                        @input="mtdSearchFilter"
                      />
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-3 col-sm-3 col-xs-3 mt-3">
                    <button
                      type="button"
                      class="btn text-white btn-sm bg-main w-100"
                      @click="mtdSyncroSunat"
                    >
                      <i class="fas fa-syncro"></i> Útima sincro:
                      {{ lastUpdate }}
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-3 text-center"
              >
                <!-- paginado -->
                <div
                  v-if="cpData.length > 0"
                  class="d-flex justify-content-end mb-2"
                >
                  <nav aria-label="Page navigation example">
                    <ul class="pagination mb-1">
                      <li class="page-item">
                        <a
                          class="page-link page"
                          href="javascript:void(0)"
                          @click="backPage"
                          >Anterior</a
                        >
                      </li>
                      <li
                        v-if="limitedStepPagination[0] !== 1"
                        class="page-item"
                      >
                        <a
                          :class="
                            selectPage === 1 ? 'page-link active' : 'page-link'
                          "
                          href="javascript:void(0)"
                          @click="selectedPage(1)"
                          >1</a
                        >
                      </li>
                      <li
                        v-if="limitedStepPagination[0] > 2"
                        class="page-item disabled"
                      >
                        <span class="page-link">...</span>
                      </li>

                      <li
                        v-for="(item, index) in limitedStepPagination"
                        :key="index"
                        class="page-item"
                      >
                        <a
                          :class="
                            selectPage === item
                              ? 'page-link active'
                              : 'page-link'
                          "
                          href="javascript:void(0)"
                          @click="selectedPage(item)"
                          >{{ item }}
                        </a>
                      </li>
                      <li
                        v-if="
                          limitedStepPagination[
                            limitedStepPagination.length - 1
                          ] <
                          stepPagination.length - 1
                        "
                        class="page-item disabled"
                      >
                        <span class="page-link">...</span>
                      </li>
                      <li
                        v-if="
                          limitedStepPagination[
                            limitedStepPagination.length - 1
                          ] !== stepPagination.length
                        "
                        class="page-item"
                      >
                        <a
                          :class="
                            selectPage === limitedStepPagination.length + 2
                              ? 'page-link active'
                              : 'page-link'
                          "
                          href="javascript:void(0)"
                          @click="selectedPage(stepPagination.length)"
                          >{{ stepPagination.length }}
                        </a>
                      </li>
                      <li class="page-item">
                        <a
                          class="page-link page"
                          href="javascript:void(0)"
                          @click="nextPage"
                          >Siguiente</a
                        >
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div class="col-md-12 mt-2" id="content-timelinetable">
                <table id="tb-anular" class="table table-bordered border-main">
                  <caption class="py-0 my-0"></caption>
                  <thead>
                    <tr class="table-th text-white text-center text-xs">
                      <th scope="col">N°</th>
                      <th scope="col">PACIENTE</th>
                      <th scope="col">FECHA</th>
                      <th scope="col">TIPO DE DOCUMENTO</th>
                      <th scope="col">N° DE DOCUMENTO</th>
                      <th scope="col">TOTAL</th>
                      <th scope="col">ESTADO</th>
                      <th scope="col">FECHA EMITIDO A SUNAT</th>
                      <th scope="col">ACCIONES</th>
                    </tr>
                  </thead>
                  <tbody class="text-xs">
                    <tr
                      class="table-body text-center"
                      v-if="cpData.length === 0"
                    >
                      <td colspan="10">No se han encontrado resultados</td>
                    </tr>
                    <tr
                      class="table-body text-center"
                      v-for="(item, index) in cpData"
                      :key="index"
                    >
                      <td scope="row">{{ mtdNumber(index) }}</td>
                      <td>
                        {{ item.sale ? item.sale.patient.document : "" }} -
                        {{ item.sale ? item.sale.patient.name : "" }}
                      </td>
                      <td class="align-center">
                        {{ item.date | formatDate }}
                      </td>
                      <td class="align-center">{{ item.document }}</td>
                      <td class="align-center">
                        {{ item.serie }}-{{ item.number }}
                      </td>
                      <td class="align-center">
                        S/ {{item.document_type_id != 3? ( item.sale != null?parseFloat(item.sale.total).toFixed(2):0.00):parseFloat(item.amount).toFixed(2) }}
                      </td>
                      <td class="align-center">
                        <span
                          v-if="item.state == 1"
                          class="badge text-bg-success"
                          >ACTIVO</span
                        >
                        <span
                          v-if="item.state == 2"
                          class="badge text-bg-danger"
                        >
                          {{
                            item.notecredit == null
                              ? "ANULADO"
                              : "CON NOTA DE CREDITO"
                          }}</span
                        >
                        <span
                          v-if="item.state == 3"
                          class="badge text-bg-warning"
                          >SIN PROCESAR</span
                        >
                      </td>
                      <td>{{ fechaSunat(item) }}</td>
                      <td>
                        <div class="d-md-flex justify-content-center">
                          <div class="px-1">
                            <button
                              type="button"
                              title="Ver ticket"
                              class="btn btn-info btn-sm btn-tooltip"
                              @click="mtdViewTicket(item)"
                            >
                              <i class="fas fa-ticket-alt"></i>
                            </button>
                          </div>
                          <button
                            @click="mtdActualizar(item)"
                            v-if="item.document !== 'TICKET'"
                            :disabled="!item.sunat"
                            title="Ver estado Sunat"
                            class="btn btn-sm btn-success text-white btn-tooltip"
                          >
                            <i class="fa fa-sync"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cModalSunatVue
      :title="modalSunat.title"
      :boo_modal="modalSunat.modal_form"
      :item="modalSunat.item"
      :garantias="modalSunat.garantias"
      :doc="modalSunat.doc"
      @closeModalSunat="closeModalSunat"
    ></cModalSunatVue>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import cModalSunatVue from "../../Gerencia/modal/cModalSunat.vue";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "c-jefatura-consultarDocumentos",
  data() {
    return {
      filter: {
        begindate: null,
        enddate: null,
        boleta: true, // Estado inicial de Boleta
        factura: true, // Estado inicial de Factura
        ticket: true,
      },
      totalPagesToShow: 4,
      page: 0,
      selectPage: 1,
      stepPagination: [],
      dataShow: [],
      data: [],
      search: "",
      modalSunat: {
        action: "",
        title: "",
        modal_form: false,
        item: [],
        garantias: [],
        doc: {},
      },
      lastUpdate: null,
    };
  },
  props: {
    prefix: {
      type: String,
      default: null,
    },
  },
  components: {
    cModalSunatVue,
  },
  created() {
    this.getFirstDayOfMonth();
    this.mtdGetData();
  },
  watch: {
    selectPage() {
      this.calculateData(10);
    },
  },
  computed: {
    cpData() {
      return this.dataShow;
    },
    limitedStepPagination() {
      const totalPages = this.stepPagination.length;
      const currentPage = this.selectPage;

      let startPage = 1;
      let endPage = totalPages;
      if (totalPages > this.totalPagesToShow) {
        const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

        if (currentPage > halfPagesToShow) {
          startPage = currentPage - halfPagesToShow;
          endPage = currentPage + halfPagesToShow - 1;

          if (endPage > totalPages) {
            endPage = totalPages;
            startPage = totalPages - this.totalPagesToShow + 1;
          }
        } else {
          endPage = this.totalPagesToShow;
        }
      }

      return Array.from(
        {
          length: endPage - startPage + 1,
        },
        (_, i) => startPage + i
      );
    },
    cpTotalFiltro() {
      let tot = 0;
      let filteredData = this.data;
      if (!this.filter.boleta) {
        filteredData = filteredData.filter(
          (item) => item.document !== "BOLETA"
        );
      }
      if (!this.filter.factura) {
        filteredData = filteredData.filter(
          (item) => item.document !== "FACTURA"
        );
      }
      if (!this.filter.ticket) {
        filteredData = filteredData.filter(
          (item) => item.document !== "TICKET"
        );
      }
      let jsonData = filteredData;
      jsonData.forEach((element) => {
        tot = parseFloat(tot) + parseFloat(element.amount);
      });
      return parseFloat(tot).toFixed(2);
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    getFirstDayOfMonth: function () {
      const currentDate = new Date();
      const firstDayOfMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() - 1
      );
      const today = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate()
      );
      this.filter.begindate = firstDayOfMonth.toISOString().split("T")[0];
      this.filter.enddate = today.toISOString().split("T")[0];
    },
    fechaSunat: function (item) {
      if (item.document !== "TICKET") {
        let ticket = JSON.parse(item.sunat);
        if (ticket) {
          let fecha = ticket.json.fecha_de_emision
            ? this.$options.filters.formatDate(ticket.json.fecha_de_emision)
            : "Aun no ha sido enviado";
          return fecha;
        } else {
          return "-";
        }
      } else {
        return "-";
      }
    },
    returnHome: function () {
      this.$emit("returnHome");
    },
    mtdGetData: function () {
      this.post({
        url: this.$store.getters.get__url + "/Jefatura/consultarDocumento",
        token: this.$store.getters.get__token,
        params: {
          begindate: this.filter.begindate,
          enddate: this.filter.enddate,
          campu_id: this.$store.getters.get__campus,
        },
      })
        .then((response) => {
          this.dataShow = [];
          this.selectPage = 1;
          this.data = response.data.voucher;
          if (this.data.length > 0) {
            this.calculateData(10);
            setTimeout(() => {
              this.activateTooltips();
            }, 1000);
          }
          this.lastUpdate = response.data.syncro
            ? response.data.syncro.date
            : "-";
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    mtdActualizar: function (item) {
      this.post({
        url:
          this.$store.getters.get__url + "/Administracion/consult/" + item.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.modalSunat.title = "DOCUMENTOS DE SUNAT";
          this.modalSunat.modal_form = true;
          this.modalSunat.item = JSON.parse(response.data);
          this.modalSunat.doc = item;
          this.modalSunat.garantias = [];
          /* if (item.sale.type == 'garantia') {
            this.dataShow.forEach(element => {
                if (element.sale.id == item.sale.id) {
                    this.modalSunat.garantias.push({
                        "tipoDocumento": "02",
                        "serie": element.serie,
                        "correlativo": element.number.padStart(8, '0'),
                        "monto": parseFloat(element.amount).toFixed(2)
                    });
                }
            });
        } */
        })
        .catch((errors) => {});
    },
    closeModalSunat: function () {
      this.modalSunat = {
        action: "",
        title: "",
        modal_form: false,
        item: [],
      };
      this.mtdGetData();
    },
    calculateData(items) {
      if (!this.data) {
        this.dataShow = [];
      }
      let filteredData = this.data;
      let selectPage = this.selectPage;
      if (this.search.length >= 2 && this.search != "") {
        let query = this.search.toString().toUpperCase();
        filteredData = this.data.filter((element) => {
          let doc = element.sale.patient.document.toString().toUpperCase();
          let name = element.sale.patient.name.toString().toUpperCase();
          let serie = element.serie.toString().toUpperCase();
          let number = element.number.toString().toUpperCase();
          return (
            doc.includes(query) ||
            name.includes(query) ||
            serie.includes(query) ||
            number.includes(query)
          );
        });
        selectPage = 1;
      }
      if (!this.filter.boleta) {
        filteredData = filteredData.filter(
          (item) => item.document !== "BOLETA"
        );
      }
      if (!this.filter.factura) {
        filteredData = filteredData.filter(
          (item) => item.document !== "FACTURA"
        );
      }
      if (!this.filter.ticket) {
        filteredData = filteredData.filter(
          (item) => item.document !== "TICKET"
        );
      }
      let totalPages = Math.ceil(filteredData.length / items);
      this.stepPagination = Array.from(
        {
          length: totalPages,
        },
        (_, index) => index + 1
      );
      if (this.selectPage > totalPages) {
        this.selectPage = totalPages || 1; // Manejar el caso donde no haya datos
      }

      let startIndex = (this.selectPage - 1) * items;
      let endIndex = startIndex + items;
      this.dataShow = filteredData.slice(startIndex, endIndex);
    },
    mtdSearchFilter() {
      this.calculateData(10);
    },
    mtdViewTicket: function (item) {
      if (item.document !== "TICKET") {
        let sunat = item.sunat;
        let json = JSON.parse(sunat);
        window.open(json.json.enlace_del_pdf_ticket, "_blank");
      } else {
        if (item.sale) {
          if (item.sale.work_order_id == null) {
            this.openTicket("/Admision/ticketVenta/", item.id);
          } else {
            this.openTicket("/Admision/ticketOrden/", item.id);
          }
        }
      }
    },
    openTicket(url, id) {
      window.open(this.$store.getters.get__url + url + id, "_blank");
    },

    backPage() {
      this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
    },
    nextPage() {
      this.selectPage =
        this.selectPage < this.stepPagination.length
          ? this.selectPage + 1
          : this.stepPagination.length;
    },
    selectedPage(page) {
      this.selectPage = page;
    },
    mtdNumber: function (index) {
      return (this.selectPage - 1) * 10 + (index + 1);
    },
    /* retroceder o volver al inicio */
    mtdChangeView: function (option) {
      this.$emit("mtdChangePage", option);
    },
    activateTooltips() {
      const tooltipTriggerList = [].slice.call(
        document.getElementsByClassName("btn-tooltip")
      );
      tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
      });
    },
    mtdSyncroSunat: async function () {
      await this.get({
        url:
          this.$store.getters.get__url +
          "/Administracion/syncro/docSunat/" +
          this.$store.getters.get__campus,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.mtdGetData();
        })
        .catch((errors) => {});
    },
    mtdDownloadExcel: function () {
      let filteredData = this.data;
      if (!this.filter.boleta) {
        filteredData = filteredData.filter(
          (item) => item.document !== "BOLETA"
        );
      }
      if (!this.filter.factura) {
        filteredData = filteredData.filter(
          (item) => item.document !== "FACTURA"
        );
      }
      if (!this.filter.ticket) {
        filteredData = filteredData.filter(
          (item) => item.document !== "TICKET"
        );
      }
      let jsonData = filteredData;
      const datosFiltrados = jsonData.map((item,index) => ({
          'N°':index +1,
          'DOCUMENTO CLIENTE': item.sale !=null ? item.sale.patient.document : "-",
          "NOMBRE CLIENTE" : item.sale !=null ? item.sale.patient.name : "-",
          'FECHA':item.date,
          'TIPO DE DOCUMENTO':item.document,
          'N° DE DOCUMENTO': item.serie + "-"+ item.number,
          'TOTAL': parseFloat(item.amount).toFixed(2),
          'ESTADO':item.state==1?'ACTIVO':(item.state == 2?'ANULADO':'SIN PROCESAR'),
          'FECHA EMITIDO A SUNAT': this.fechaSunat(item),
        }));

      // Convertir JSON a hoja de cálculo
      const worksheet = XLSX.utils.json_to_sheet(datosFiltrados);

      // Crear libro de Excel y agregar hoja
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");

      // Convertir a blob
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      // Descargar el archivo
      saveAs(blob, "Docuemntos.xlsx");
    },
  },
  filters: {
    formatDate(date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
  },
};
</script>
